import {
    Form, FormButton, FormButtonContainer, FormItem, FormSubmitHandler, MaskedInput, SwitchInput, TextInput, useAlerts, useForm,
} from "@sis/react-library"
import { ExampleDto } from "./FormSamplesInitialValuesPage";

/////////////////////////////////////////////////////////////////////////////////////////////
// Interface for the form (see basic usage example for more information).
/////////////////////////////////////////////////////////////////////////////////////////////
// allow no members for shorter name to be more readable below
// eslint-disable-next-line
interface T extends ExampleDto { }

interface FormSamplesInitialValuesFormProps {
    initialValues: ExampleDto;
    onSubmit: FormSubmitHandler<ExampleDto>;
    submitting: boolean;
}

export const FormSamplesInitialValuesForm = ({
    initialValues, onSubmit, submitting
}: FormSamplesInitialValuesFormProps) => {

    const formName = 'FormInitialValues';

    const { resetForm } = useForm<T>(formName);
    const { confirm } = useAlerts();

    const handleCancel = () => {
        confirm('Cancel', 'Are you sure you want to cancel and loose your changes?',
            () => { resetForm() },
            "Yes", "No"
        );
    }

    return (
        <Form<T>
            name={formName}
            onSubmit={onSubmit}
            submitting={submitting}
            initialValues={initialValues}  // Pass through the initial values of the form
            beforeLeaveText='You have made changes, are you sure you want to leave ?'
            /////////////////////////////////////////////////////////////////////////////////
            // additionalItems is where you can create extra items for the form to keep
            // track of where there's no user input.
            // This is where we keep the id so it can be submitted as part of the form.
            /////////////////////////////////////////////////////////////////////////////////
            additionalItems={[{ name: "id" }]}
        >
            <FormItem<T>
                formField="firstName"
                label="First Name"
                element={<TextInput maxLength={20} />}
            />
            <FormItem<T>
                formField="lastName"
                label="Last Name"
                element={<TextInput maxLength={20} />}
            />
            <FormItem<T>
                formField="isEmployed"
                label="Is Employed"
                element={<SwitchInput />}
            />
            <FormItem<T>
                formField="phoneNo"
                label="Phone Number"
                element={<MaskedInput maskedType="PhoneNumber" />}                
            />
            <FormButtonContainer>
                <FormButton
                    formButtonText='Cancel'
                    onClick={() => { handleCancel() }}
                />
                <FormButton
                    formButtonText='Submit'
                    submitButton
                />
            </FormButtonContainer>
        </Form>
    )
}
